import React from "react";
import { SOURCE_STATUS } from "../features/builder.constants";

// Lifecycle pill of a source (Draft / Active / Paused / Archived), optionally with its version.
export default function LifecycleBadge({ status, version }) {
  const meta = SOURCE_STATUS[status] || SOURCE_STATUS.DRAFT;
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold ${meta.classes}`}>
        {meta.label}
      </span>
      {version !== undefined && version !== null && <span className="text-[11px] text-text_muted">v{version}</span>}
    </span>
  );
}
